import { render, staticRenderFns } from "./ExplainList.vue?vue&type=template&id=22285f03&scoped=true&"
import script from "./ExplainList.vue?vue&type=script&lang=js&"
export * from "./ExplainList.vue?vue&type=script&lang=js&"
import style0 from "./ExplainList.vue?vue&type=style&index=0&id=22285f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22285f03",
  null
  
)

export default component.exports